import { FC, memo, useCallback } from 'react';
import { ButtonWrapper } from '@tempusfinance/common-ui';
import Typography from '../../Typography';

import './ButtonGroupItem.scss';

interface ButtonGroupItemProps {
  label: string;
  value: string;
  active: boolean;
  disabled: boolean;
  onClick: (value: string) => void;
}

const ButtonGroupItemComponent: FC<ButtonGroupItemProps> = ({ label, value, active, disabled, onClick }) => {
  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }

    onClick(value);
  }, [disabled, onClick, value]);

  return (
    <ButtonWrapper className="nostra__buttonGroupItem" data-active={active} disabled={disabled} onClick={handleClick}>
      <Typography
        variant="button-sm"
        color={active ? 'text-primary-darkbg' : 'text-supporting'}
        weight={active ? 'semi-bold' : 'regular'}
      >
        {label}
      </Typography>
    </ButtonWrapper>
  );
};
export const ButtonGroupItem = memo(ButtonGroupItemComponent);
